import BadgeBase from "../BadgeBase";

export default function Pill({
  children,
  selected = false,
  onClick,
  sx,
  ...props
}) {
  return (
    <BadgeBase
      tone={selected ? "primary" : "neutral"}
      shape="pill"
      size="lg"
      onClick={onClick}
      sx={{
        cursor: onClick ? "pointer" : "default",
        minHeight: 36,
        px: 1.5,
        ...sx,
      }}
      {...props}
    >
      {children}
    </BadgeBase>
  );
}
